import React, { Component } from 'react';
import Drawer from '@material-ui/core/Drawer'
import Divider from '@material-ui/core/Divider'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

export class Navigation extends Component {

  body = document.querySelector('body');

  state = {
    expandedPanel: null,
  };

  hanldePanelExpansion = panel => (event, expandedPanel) => {
    this.setState({
      expandedPanel: expandedPanel ? panel : false,
    });
  };

  render() {

    const { expandedPanel } = this.state;

    this.props.open ? this.body.style = `position:fixed;height:100%;width:100%;overflow:hidden;`: this.body.removeAttribute('style')

    return (
      <ClickAwayListener onClickAway={this.props.onClickAway}>
        <Drawer
          open={this.props.open}
          variant="persistent"
          anchor="left"
          className="side-nav"
        >
            <ul className="unstyled-list overflow-x-hidden">
                <li className="side-nav__section">
                    <NavLink onClick={this.props.onLinkClick} to="/" className="side-nav__header-wrapper side-nav__header-wrapper--home">
                        <img src="./assets/icons/home.svg" alt="Home" style={{height: "28px", width: "28px"}}/>
                        <div className="side-nav__heading side-nav__heading--large">Home</div>
                    </NavLink>
                </li>
                <li className="side-nav__section">
                    <a href="https://www.southwest.com/rapid-rewards/cargo/#apply" className="side-nav__header-wrapper side-nav__header-wrapper--home">

                        <img src="./assets/home/rapid-rewards-mobile-menu.svg" alt="Rapid Rewards" style={{height: "28px", width: "28px"}}/>
                        <div className="side-nav__heading side-nav__heading--large"><span>Rapid Rewards<sup>®</sup> Cargo</span></div>
                    </a>
                </li>

                <li>
                    <Divider/>
                </li>
                <li className="side-nav__section side-nav__section--top">
                    <ExpansionPanel
                            className="side-nav__header-wrapper"
                            expanded={expandedPanel === 'panel1'}
                            onChange={this.hanldePanelExpansion('panel1')}
                    >
                        <ExpansionPanelSummary
                                className="side-nav__header"
                                expandIcon={<ExpandMoreIcon className="side-nav__expand-icon"/>}
                        >
                            <img src="./assets/icons/shipping.svg" alt="Ship" style={{height: "28px", width: "28px"}}/>
                            <div className="side-nav__heading side-nav__heading--medium">Ship</div>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className="sub-nav-wrapper">
                            <ul className="unstyled-list side-nav__sub-nav">
                                <li className="sub-nav__item">
                                    <NavLink onClick={this.props.onLinkClick} to="/ship/products" className="sub-nav__link">Products</NavLink>
                                </li>
                                <li className="sub-nav__item">
                                    <NavLink onClick={this.props.onLinkClick} to="/ship/rates" className="sub-nav__link">Rates</NavLink>
                                </li>
                                <li className="sub-nav__item">
                                    <NavLink onClick={this.props.onLinkClick} to="/ship/guidelines-and-tools" className="sub-nav__link">Guidelines & Tools</NavLink>
                                </li>
                                <li className="sub-nav__item">
                                    <NavLink onClick={this.props.onLinkClick} to="/ship/facilities" className="sub-nav__link">Facilities</NavLink>
                                </li>
                                <li className="sub-nav__item">
                                    <NavLink onClick={this.props.onLinkClick} to="/ship/flight-schedules" className="sub-nav__link">Flight Schedules</NavLink>
                                </li>
                                <li className="sub-nav__item">
                                    <NavLink onClick={this.props.onLinkClick} to="/ship/charges-and-payments" className="sub-nav__link">Charges & Payments</NavLink>
                                </li>
                                <li className="sub-nav__item">
                                    <NavLink onClick={this.props.onLinkClick} to="/ship/book" className="sub-nav__link">Book</NavLink>
                                </li>
                            </ul>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </li>
                <li className="side-nav__section">
                    <ExpansionPanel
                            className="side-nav__header-wrapper"
                            expanded={expandedPanel === 'panel2'}
                            onChange={this.hanldePanelExpansion('panel2')}
                    >
                        <ExpansionPanelSummary
                                className="side-nav__header"
                                expandIcon={<ExpandMoreIcon className="side-nav__expand-icon"/>}
                        >
                            <img src="./assets/icons/list.svg" alt="Manage" style={{height: "28px", width: "28px"}}/>
                            <div className="side-nav__heading">Manage</div>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className="sub-nav-wrapper">
                            <ul className="unstyled-list side-nav__sub-nav">
                                <li className="sub-nav__item">
                                    <NavLink onClick={this.props.onLinkClick} to="/manage/tracking" className="sub-nav__link">Track your shipment</NavLink>
                                </li>
                                <li className="sub-nav__item">
                                    <a onClick={this.props.onLinkClick} href="https://www.southwest.com/air/flight-status/index.html?REF=SWACARGO" target="_blank"
                                       rel="noopener noreferrer" className="external-link sub-nav__link sub-nav__link--external">Flight Status</a>
                                </li>
                                <li className="sub-nav__item">
                                    <NavLink onClick={this.props.onLinkClick} to="/manage/file-a-claim" className="sub-nav__link">File A Claim</NavLink>
                                </li>
                                <li className="sub-nav__item">
                                    <NavLink onClick={this.props.onLinkClick} to="/manage/forms-and-applications" className="sub-nav__link">Forms & Applications</NavLink>
                                </li>
                            </ul>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </li>

                <li className="side-nav__section">
                    <ExpansionPanel
                            className="side-nav__header-wrapper"
                            expanded={expandedPanel === 'panel3'}
                            onChange={this.hanldePanelExpansion('panel3')}
                    >
                        <ExpansionPanelSummary
                                className="side-nav__header"
                                expandIcon={<ExpandMoreIcon className="side-nav__expand-icon"/>}
                        >
                            <img src="./assets/icons/lightbulb.svg" alt="Learn" style={{height: "28px", width: "28px"}}/>
                            <div className="side-nav__heading">Learn</div>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className="sub-nav-wrapper">
                            <ul className="unstyled-list side-nav__sub-nav">
                                <li className="sub-nav__item">
                                    <NavLink onClick={this.props.onLinkClick} to="/learn/how-to-ship" className="sub-nav__link">How to Ship</NavLink>
                                </li>
                                <li className="sub-nav__item">
                                    <NavLink onClick={this.props.onLinkClick} to="/learn/specialty-shipments" className="sub-nav__link">Specialty Shipments</NavLink>
                                </li>
                                <li className="sub-nav__item">
                                    <NavLink onClick={this.props.onLinkClick} to="/learn/faq" className="sub-nav__link">FAQ</NavLink>
                                </li>
                                <li className="sub-nav__item">
                                    <NavLink onClick={this.props.onLinkClick} to="/learn/declared-value" className="sub-nav__link">Declared Value</NavLink>
                                </li>
                                <li className="sub-nav__item">
                                    <NavLink onClick={this.props.onLinkClick} to="/training" className="sub-nav__link">Training</NavLink>
                                </li>
                            </ul>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </li>


                <li className="side-nav__section side-nav__section--bottom">
                    <ExpansionPanel
                            className="side-nav__header-wrapper"
                            expanded={expandedPanel === 'panel4'}
                            onChange={this.hanldePanelExpansion('panel4')}
                    >
                        <ExpansionPanelSummary
                                className="side-nav__header"
                                expandIcon={<ExpandMoreIcon className="side-nav__expand-icon"/>}
                        >
                            <img src="./assets/icons/tooltip.svg" alt="About" style={{height: "20px", width: "20px", marginLeft: "5px"}}/>
                            <div className="side-nav__heading">About</div>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className="sub-nav-wrapper">
                            <ul className="unstyled-list side-nav__sub-nav">
                                <li className="sub-nav__item">
                                    <NavLink onClick={this.props.onLinkClick} to="/about/our-story" className="sub-nav__link">Our Story</NavLink>
                                </li>
                                <li className="sub-nav__item">
                                    <NavLink onClick={this.props.onLinkClick} to="/about/awards" className="sub-nav__link">Awards</NavLink>
                                </li>
                                <li className="sub-nav__item">
                                    <NavLink onClick={this.props.onLinkClick} to="/about/press-releases" className="sub-nav__link">Press Releases</NavLink>
                                </li>
                                <li className="sub-nav__item">
                                    <NavLink onClick={this.props.onLinkClick} to="/about/news" className="sub-nav__link">News</NavLink>
                                </li>
                                <li className="sub-nav__item">
                                    <NavLink onClick={this.props.onLinkClick} to="/about/customer-testimonials" className="sub-nav__link">Customer Testimonials</NavLink>
                                </li>
                            </ul>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </li>
                <li>
                    <Divider/>
                </li>
                <li className="side-nav__section side-nav__section--contact-us">
                    <div className="side-nav__header-wrapper">
                        <div className="side-nav__heading side-nav__heading--no-icon side-nav__heading--large">Contact us</div>
                    </div>
                    <ul className="unstyled-list side-nav__sub-nav side-nav__sub-nav--contact-us">
                        <li className="sub-nav__item">
                            <img src="./assets/icons/smartphone.svg" alt="Call Us" style={{height: "28px", width: "28px"}}/>
                            <NavLink onClick={this.props.onLinkClick} to="/contact" className="sub-nav__link">Call Us</NavLink>
                        </li>
                    </ul>
                </li>
                <li>
                    <Divider/>
                </li>
                <li className="side-nav__section">
                    <ul className="unstyled-list">
                        <li>
                            <a onClick={this.props.onLinkClick} href="https://www.southwest.com/" target="_blank"
                               rel="noopener noreferrer"
                               className="bottom-nav__link">Visit Southwest.com</a>
                        </li>
                        <li>
                            <a onClick={this.props.onLinkClick} href="https://www.southwestaircommunity.com/" target="_blank"
                               rel="noopener noreferrer"
                               className="bottom-nav__link">The Southwest Community</a>
                        </li>
                        <li>
                            <a onClick={this.props.onLinkClick} href="https://www.swabiz.com/" target="_blank"
                               rel="noopener noreferrer" className="bottom-nav__link">SWABIZ</a>
                        </li>
                        <li>
                            <NavLink onClick={this.props.onLinkClick} to="/terms-and-conditions" className="bottom-nav__link">Terms & Conditions</NavLink>
                        </li>
                        <li>
                            <NavLink onClick={this.props.onLinkClick} to="/privacy-policy" className="bottom-nav__link">Privacy Policy</NavLink>
                        </li>
                    </ul>
                </li>
            </ul>
            <div className="side-nav__copyright">
                © 2018 Southwest Airlines Co. <span>All Rights Reserved.</span>
            </div>
        </Drawer>
      </ClickAwayListener>
    )
  }
}

export default Navigation;

Navigation.propTypes = {
    open: PropTypes.bool.isRequired,
    onClickAway: PropTypes.func.isRequired,
    onLinkClick: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.js